// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunks/" + {"74":"admin-shell-users","137":"admin-shell-modules","347":"admin-shell-modules-catalog","426":"admin-shell-permissions","482":"admin-shell-dashboard","565":"admin-shell-roles","577":"admin-shell-profile"}[chunkId] + ".js";
};